var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("RecruitingIcon", {
                    staticClass: "h-8 w-8 fill-current text-primary-500 mr-2",
                  }),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.CUSTOM_REQUESTS,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-semibold text-base" }, [
                        _vm._v(" Skills and People I need "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "UiButton",
                {
                  attrs: { textClass: "whitespace-no-wrap" },
                  on: {
                    click: function ($event) {
                      _vm.modalShown = true
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("PlusIcon", {
                            staticClass: "text-white fill-current w-2.5 h-2.5",
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("span", { staticClass: "flex" }, [
                    _vm._v(" Resource Request "),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("CardItemScaffold", {
        attrs: {
          itemNumber: _vm.customRequestsCount,
          itemTitle: "External Sourcing",
        },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("SimplePersonIcon", {
                  staticClass: "h-5 w-5 fill-current text-primary-500",
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "CardItemScaffold",
        {
          attrs: {
            itemNumber: _vm.contractorRequestsCount,
            itemTitle: "Contractor Requests",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.contractorsInfo,
              moreNumber: _vm.contractorRequestsCount,
              navigateTo: { name: _vm.routes.CONTRACTORS_REQUESTS },
              maxChipWidth: "max-w-40",
              isPerson: "",
            },
          }),
        ],
        1
      ),
      _vm.modalShown
        ? _c("CustomRequestModal", {
            staticClass: "flex flex-grow justify-end",
            attrs: {
              companyId: _vm.companyId,
              currentUserId: _vm.currentUserId,
            },
            on: {
              close: function ($event) {
                _vm.modalShown = false
              },
              refetch: function ($event) {
                return _vm.$apollo.queries.requests.refetch()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }